// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.basUI {
  /* input, select, radio, check box styles */
}
.basUI header {
  box-shadow: none;
}
.basUI .height-40 {
  min-height: 40px !important;
}
.basUI .hr-line {
  margin: 30px 0;
  height: 1px;
  width: 100%;
  display: block;
  clear: both;
}
.basUI .footertxt {
  position: relative;
}
.basUI .footertxt b {
  background: #fff;
  position: relative;
  z-index: 1;
  padding-right: 15px;
}
.basUI .footertxt:after {
  width: 100%;
  height: 1px;
  background: #C5C5C5;
  content: "";
  position: absolute;
  left: 0;
  top: 10px;
}
.basUI a {
  color: #1074E9;
}
.basUI a:hover {
  color: #000;
}
.basUI .form-control {
  border-radius: 6px;
  min-height: 40px;
  border: 0;
}
.basUI input.form-control::placeholder,
.basUI select.form-control::placeholder,
.basUI textarea::placeholder {
  font-size: 14px;
  color: #0D4582;
}
.basUI select.form-control option:first-child {
  color: #0D4582;
}
.basUI select.form-control {
  font-size: 13px;
}
.basUI ul,
.basUI li {
  font-size: 14px;
}
.basUI p {
  font-size: 14px;
}
.basUI .btn {
  border-radius: 100px;
  min-height: 45px;
  font-size: 14px;
}
.basUI .btn-primary {
  background-color: #93CF0C;
  border: 0;
  color: #fff;
}
.basUI .btn-primary:hover {
  background-color: #69910F;
}
.basUI .btn-secondary {
  background-color: #217AFF;
  border: 0;
}
.basUI .btn-secondary:hover {
  background-color: #022D6D;
}
.basUI select {
  background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #fff, #fff);
  background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
}
.basUI select {
  /* styling */
  background-color: white;
  border: thin solid blue;
  border-radius: 4px;
  display: inline-block;
  font: inherit;
  line-height: 1.5em;
  padding: 0.5em 3.5em 0.5em 1em;
  /* reset */
  margin: 0;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 35px !important;
}
.basUI.bg-blue {
  width: 100%;
  height: 100%;
  position: relative;
}
.basUI.bg-blue:after {
  background-color: #022D6D;
  width: 55%;
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  content: "";
  z-index: 0;
}
.basUI .container-wrap {
  position: relative;
  z-index: 1;
}
.basUI .head-line {
  position: relative;
  padding-bottom: 10px;
}
.basUI .head-line:after {
  background-color: #A2E609;
  position: absolute;
  width: 40px;
  height: 3px;
  content: "";
  bottom: 0;
  left: 0;
}
.basUI .progress-edit {
  height: 6px;
  border-radius: 50px;
  background: #051C3E;
}
.basUI .progress-edit .bg-success {
  height: 6px;
  border-radius: 50px;
  background-color: #84B80F !important;
}
.basUI #myTab * {
  transition: all 0.15s ease-in-out;
}
.basUI .nav-tabs-custom {
  border-bottom: 0;
}
.basUI .nav-tabs-custom .nav-link.active,
.basUI .nav-tabs-custom .nav-link {
  background-color: transparent;
  border: none;
  color: #fff;
}
.basUI .nav-tabs-custom .nav-link {
  background-color: transparent;
  border: none;
  color: #98BBDF;
  padding: 0 0 7px;
  margin-right: 40px;
  font-size: 14px;
  position: relative;
}
.basUI .nav-tabs-custom .nav-link::after {
  position: absolute;
  bottom: 0;
  left: 0;
  content: "";
  width: 0;
  background: #2C60AE;
  height: 2px;
  transition: all 0.15s ease-in-out;
}
.basUI .nav-tabs-custom .nav-link.active {
  padding-bottom: 7px;
}
.basUI .nav-tabs-custom .nav-link.active::after {
  width: 100%;
  transition: all 0.15s ease-in-out;
}
.basUI .right {
  padding: 0 100px;
}
.basUI .custom-choose input[type=radio],
.basUI .custom-choose input[type=checkbox] {
  display: none;
}
.basUI .custom-choose input[type=radio] + label,
.basUI .custom-choose input[type=radio]:not(checked) + label,
.basUI .custom-choose input[type=checkbox] + label,
.basUI .custom-choose input[type=checkbox]:not(checked) + label {
  padding-left: 15px;
  transition: 0.4s;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 0;
  border-radius: 6px;
  width: 100%;
  text-align: left;
  cursor: pointer;
  min-height: 40px;
  font-size: 14px;
  background-image: url("https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/checked.svg");
  background-position: right;
  background-repeat: no-repeat;
}
.basUI .custom-choose label {
  position: relative;
  font-size: 14px;
  display: flex;
  align-items: center;
  color: #000;
}
.basUI .custom-choose label i.tick {
  position: absolute;
  right: 15px;
  font-size: 16px;
  top: 15px;
}
.basUI .custom-choose label i.tick:before {
  color: #D5D5D5;
}
.basUI .custom-choose input[type=checkbox]:checked + label i:before,
.basUI .custom-choose input[type=radio]:checked + label i:before {
  color: #fff;
}
@media (min-width: 1200px) {
  .basUI .custom-choose .col-xl-3 {
    flex: 0 0 auto;
    width: 20%;
  }
}
.basUI .custom-choose input[type=radio]:checked + label,
.basUI .custom-choose input[type=checkbox]:checked + label {
  position: relative;
  border: solid 2px #217AFF;
  background: #217AFF;
  color: #FFF;
  transition: 0.4s;
  border: 0;
  background-image: url("https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/checked-white.svg");
  background-position: right;
  background-repeat: no-repeat;
}
.basUI .custom-choose span.col {
  padding: 0 5px;
  color: #D5D5D5;
}
.basUI .custom-choose .height-60 label {
  height: 60px;
  display: inherit;
  flex-direction: column !important;
}
.basUI .modal-wrap .close {
  position: absolute;
  z-index: 2;
  right: 20px;
  top: 15px;
}
.basUI .mrl-5less {
  margin-left: -5px;
  margin-right: -5px;
}
.basUI .mrl-15less {
  margin-left: -15px;
  margin-right: -15px;
}
.basUI .crl-15less span {
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 4px;
}
.basUI .br-left {
  position: relative;
}
.basUI .br-left::before {
  width: 3px;
  height: 25px;
  background-color: #EC9A20;
  position: absolute;
  content: "";
  left: 15px;
  top: 5px;
}
.basUI .list-orange li {
  position: relative;
  padding-left: 30px;
}
.basUI .list-orange li .badge {
  position: absolute;
  left: 0;
  top: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #EF6910;
  color: #fff;
}
.basUI .scheduled {
  background-color: #EEF4FF;
  padding: 20px;
  color: #000;
  border-radius: 4px;
}
.basUI .scheduled p {
  padding-left: 35px;
  position: relative;
}
.basUI .scheduled img {
  position: absolute;
  left: 0;
}
.basUI p.list-number {
  position: relative;
  padding-left: 30px;
}
.basUI p.list-number .badge {
  position: absolute;
  left: 0;
  top: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #EF6910;
  color: #fff;
}
@media (max-width: 991.98px) {
  .basUI.bg-blue:after {
    width: 100%;
    background-color: transparent;
  }
  .basUI .bg-blue-mobile {
    width: 100%;
    background-color: #022D6D !important;
  }
  .basUI .right {
    padding: 0px;
  }
  .basUI .d-none-mobile {
    display: none;
  }
  .basUI .d-none-desktop {
    display: block;
  }
  .basUI .container-wrap {
    width: 100% !important;
    max-width: 100% !important;
  }
  .basUI a[aria-expanded=true] > u.read {
    font-size: 0;
  }
  .basUI a[aria-expanded=true] > u.read::after {
    content: "Read Less";
    font-size: 14px;
  }
  .basUI .fixed-btn-bg {
    position: fixed;
    bottom: -65px;
    right: 0;
    left: 0;
    background: #fff;
    padding: 10px 0;
    transition: all 0.3s ease-in-out;
    width: 100% !important;
    display: flex;
    justify-content: center;
  }
  .basUI .fixed-btn-bg.smart-scroll.scrolled-up {
    bottom: 0;
    transition: all 0.3s ease-in-out;
  }
  .basUI .fixed-btn-bg .btn {
    width: 100% !important;
    max-width: 250px;
    margin: 0 !important;
  }
}
@media (min-width: 1199.98px) {
  .basUI .d-none-desktop {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/css/BASstyles.scss","webpack://./src/styles/css/BASstyles.css"],"names":[],"mappings":"AAAA;EAwCA,2CAAA;ACtCA;ADAA;EACI,gBAAA;ACEJ;ADCA;EACI,2BAAA;ACCJ;ADEA;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;ACAJ;ADGA;EACI,kBAAA;ACDJ;ADGI;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;ACDJ;ADII;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;ACFJ;ADSA;EACI,cAAA;ACPJ;ADSI;EACI,WAAA;ACPR;ADWA;EACI,kBAAA;EACA,gBAAA;EACA,SAAA;ACTJ;ADYA;;;EAGI,eAAA;EACA,cAAA;ACVJ;ADaA;EACI,cAAA;ACXJ;ADcA;EACI,eAAA;ACZJ;ADeA;;EAEI,eAAA;ACbJ;ADgBA;EACI,eAAA;ACdJ;ADiBA;EACI,oBAAA;EACA,gBAAA;EACA,eAAA;ACfJ;ADiBI;EACI,yBAAA;EACA,SAAA;EACA,WAAA;ACfR;ADiBQ;EACI,yBAAA;ACfZ;ADmBI;EACI,yBAAA;EACA,SAAA;ACjBR;ADmBQ;EACI,yBAAA;ACjBZ;ADsBA;EACI,8JAAA;EACA,mHAAA;EACA,4CAAA;EACA,4BAAA;ACpBJ;ADuBA;EACI,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,UAAA;EACA,SAAA;EAGA,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,8BAAA;ACrBJ;ADwBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;ACtBJ;ADwBI;EACI,yBAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;ACtBR;AD4BA;EACI,kBAAA;EACA,UAAA;AC1BJ;AD6BA;EACI,kBAAA;EACA,oBAAA;AC3BJ;AD6BI;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;AC3BJ;AD+BA;EACI,WAAA;EACA,mBAAA;EACA,mBAAA;AC7BJ;AD+BI;EACI,WAAA;EACA,mBAAA;EACA,oCAAA;AC7BR;ADiCA;EAKI,iCAAA;AC/BJ;ADiCA;EACI,gBAAA;AC/BJ;ADiCI;;EAEI,6BAAA;EACA,YAAA;EACA,WAAA;AC/BR;ADmCI;EACI,6BAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;ACjCR;ADmCQ;EACK,kBAAA;EACG,SAAA;EACA,OAAA;EACA,WAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EAKA,iCAAA;ACjChB;ADoCQ;EACI,mBAAA;AClCZ;ADoCY;EACI,WAAA;EAKA,iCAAA;AClChB;ADwCA;EACI,gBAAA;ACtCJ;AD0CA;;EAEI,aAAA;ACxCJ;AD2CA;;;;EAII,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iHAAA;EACA,0BAAA;EACA,4BAAA;ACzCJ;AD6CI;EACI,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AC3CR;AD8CY;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AC5ChB;AD6CgB;EACI,cAAA;AC3CpB;ADqDgB;;EACI,WAAA;AClDpB;ADyDA;EACI;IACI,cAAA;IACA,UAAA;ECvDN;AACF;AD0DA;;EAEI,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,uHAAA;EACA,0BAAA;EACA,4BAAA;ACxDJ;AD2DA;EACI,cAAA;EACA,cAAA;ACzDJ;AD4DA;EACI,YAAA;EACA,gBAAA;EAEA,iCAAA;AC1DJ;AD6DA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;AC3DJ;AD8DA;EACI,iBAAA;EACA,kBAAA;AC5DJ;AD+DA;EACI,kBAAA;EACA,mBAAA;AC7DJ;ADgEA;EACI,iBAAA;EACA,kBAAA;EACA,kBAAA;AC9DJ;ADiEA;EACI,kBAAA;AC/DJ;ADkEA;EACI,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;AChEJ;ADmEA;EACI,kBAAA;EACA,kBAAA;ACjEJ;ADoEA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;AClEJ;ADqEA;EACI,yBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;ACnEJ;ADqEI;EACA,kBAAA;EACA,kBAAA;ACnEJ;ADsEI;EACA,kBAAA;EACA,OAAA;ACpEJ;ADyEI;EACI,kBAAA;EACA,kBAAA;ACvER;ADyEQ;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;ACvEZ;ADgFA;EACI;IACI,WAAA;IACA,6BAAA;EC9EN;EDgFE;IACI,WAAA;IACA,oCAAA;EC9EN;EDgFE;IACI,YAAA;EC9EN;EDgFE;IACI,aAAA;EC9EN;EDgFE;IACI,cAAA;EC9EN;EDgFE;IACI,sBAAA;IACA,0BAAA;EC9EN;EDgFE;IACI,YAAA;EC9EN;EDgFE;IACI,oBAAA;IACA,eAAA;EC9EN;EDgFE;IACI,eAAA;IACA,aAAA;IACA,QAAA;IACA,OAAA;IACA,gBAAA;IACA,eAAA;IAKA,gCAAA;IACA,sBAAA;IACA,aAAA;IACA,uBAAA;EC9EN;EDgFE;IACI,SAAA;IAKA,gCAAA;EC9EN;EDgFE;IACI,sBAAA;IACA,gBAAA;IACA,oBAAA;EC9EN;AACF;ADmFA;EACI;IACI,aAAA;ECjFN;AACF","sourcesContent":[".basUI{\n    \nheader{\n    box-shadow: none;\n}\n\n.height-40 {\n    min-height: 40px !important;\n}\n\n.hr-line {\n    margin: 30px 0;\n    height: 1px;\n    width: 100%;\n    display: block;\n    clear: both;\n}\n\n.footertxt {\n    position: relative;\n\n    b {\n    background: #fff;\n    position: relative;\n    z-index: 1;\n    padding-right: 15px;\n    }\n\n    &:after {\n    width: 100%;\n    height: 1px;\n    background: #C5C5C5;\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 10px;\n    }\n}\n\n\n/* input, select, radio, check box styles */\n\na {\n    color: #1074E9;\n\n    &:hover {\n        color: #000;\n    }\n}\n\n.form-control {\n    border-radius: 6px;\n    min-height: 40px;\n    border: 0;\n}\n\ninput.form-control::placeholder,\nselect.form-control::placeholder,\ntextarea::placeholder {\n    font-size: 14px;\n    color: #0D4582;\n}\n\nselect.form-control option:first-child {\n    color: #0D4582;\n}\n\nselect.form-control {\n    font-size: 13px;\n}\n\nul,\nli {\n    font-size: 14px;\n}\n\np {\n    font-size: 14px;\n}\n\n.btn {\n    border-radius: 100px;\n    min-height: 45px;\n    font-size: 14px;\n\n    &-primary {\n        background-color: #93CF0C;\n        border: 0;\n        color: #fff;\n\n        &:hover {\n            background-color: #69910F;\n        }\n    }\n\n    &-secondary {\n        background-color: #217AFF;\n        border: 0;\n\n        &:hover {\n            background-color: #022D6D;\n        }\n    }\n}\n\nselect {\n    background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #fff, #fff);\n    background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;\n    background-size: 5px 5px, 5px 5px, 1px 1.5em;\n    background-repeat: no-repeat;\n}\n\nselect {\n    /* styling */\n    background-color: white;\n    border: thin solid blue;\n    border-radius: 4px;\n    display: inline-block;\n    font: inherit;\n    line-height: 1.5em;\n    padding: 0.5em 3.5em 0.5em 1em;\n    /* reset */\n    margin: 0;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    padding-right: 35px !important;\n}\n\n&.bg-blue {\n    width: 100%;\n    height: 100%;\n    position: relative;\n\n    &:after {\n        background-color: #022D6D;\n        width: 55%;\n        position: fixed;\n        right: 0;\n        top: 0;\n        height: 100%;\n        content: \"\";\n        z-index: 0;\n    }\n}\n\n\n\n.container-wrap {\n    position: relative;\n    z-index: 1;\n}\n\n.head-line {\n    position: relative;\n    padding-bottom: 10px;\n\n    &:after {\n    background-color: #A2E609;\n    position: absolute;\n    width: 40px;\n    height: 3px;\n    content: \"\";\n    bottom: 0;\n    left: 0;\n    }\n}\n\n.progress-edit {\n    height: 6px;\n    border-radius: 50px;\n    background: #051C3E;\n\n    .bg-success {\n        height: 6px;\n        border-radius: 50px;\n        background-color: #84B80F !important;\n    }\n}\n\n#myTab * {\n    -webkit-transition: all 0.15s ease-in-out;\n    -moz-transition: all 0.15s ease-in-out;\n    -ms-transition: all 0.15s ease-in-out;\n    -o-transition: all 0.15s ease-in-out;\n    transition: all 0.15s ease-in-out;\n}\n.nav-tabs-custom {\n    border-bottom: 0;\n\n    .nav-link.active,\n    .nav-link {\n        background-color: transparent;\n        border: none;\n        color: #fff;\n    }\n\n\n    .nav-link {\n        background-color: transparent;\n        border: none;\n        color: #98BBDF;\n        padding: 0 0 7px;\n        margin-right: 40px;\n        font-size: 14px;\n        position: relative;\n\n        &::after {\n             position: absolute;\n                bottom: 0;\n                left: 0;\n                content: '';\n                width: 0;\n                background: #2C60AE;\n                height: 2px;\n                -webkit-transition: all 0.15s ease-in-out;\n                -moz-transition: all 0.15s ease-in-out;\n                -ms-transition: all 0.15s ease-in-out;\n                -o-transition: all 0.15s ease-in-out;\n                transition: all 0.15s ease-in-out;\n            }\n\n        &.active {\n            padding-bottom: 7px;\n\n            &::after {\n                width: 100%;\n                -webkit-transition: all 0.15s ease-in-out;\n                -moz-transition: all 0.15s ease-in-out;\n                -ms-transition: all 0.15s ease-in-out;\n                -o-transition: all 0.15s ease-in-out;\n                transition: all 0.15s ease-in-out;\n            }\n        }\n    }\n}\n\n.right {\n    padding: 0 100px;\n}\n\n\n.custom-choose input[type='radio'],\n.custom-choose input[type='checkbox'] {\n    display: none;\n}\n\n.custom-choose input[type='radio']+label,\n.custom-choose input[type='radio']:not(checked)+label,\n.custom-choose input[type='checkbox']+label,\n.custom-choose input[type='checkbox']:not(checked)+label {\n    padding-left: 15px;\n    transition: .4s;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border: 0;\n    border-radius: 6px;\n    width: 100%;\n    text-align: left;\n    cursor: pointer;\n    min-height: 40px;\n    font-size: 14px;\n    background-image: url('https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/checked.svg');\n    background-position: right;\n    background-repeat: no-repeat;\n}\n\n.custom-choose {\n    label {\n        position: relative;\n        font-size: 14px;\n        display: flex;\n        align-items: center;\n        color: #000;\n\n        i {\n            &.tick {\n                position: absolute;\n                right: 15px;\n                font-size: 16px;\n                top: 15px;\n                &:before {\n                    color: #D5D5D5;\n                }\n            }\n        }\n    }\n\n    input[type='checkbox'],\n    input[type='radio'] {\n        &:checked+label {\n            i {\n                &:before {\n                    color: #fff;\n                }\n            }\n        }\n    }\n}\n\n@media (min-width: 1200px) {\n    .custom-choose .col-xl-3 {\n        flex: 0 0 auto;\n        width: 20%;\n    }\n}\n\n.custom-choose input[type='radio']:checked+label,\n.custom-choose input[type='checkbox']:checked+label {\n    position: relative;\n    border: solid 2px #217AFF;\n    background: #217AFF;\n    color: #FFF;\n    transition: .4s;\n    border: 0;\n    background-image: url('https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/checked-white.svg');\n    background-position: right;\n    background-repeat: no-repeat;\n}\n\n.custom-choose span.col {\n    padding: 0 5px;\n    color: #D5D5D5;\n}\n\n.custom-choose .height-60 label {\n    height: 60px;\n    display: inherit;\n    -ms-flex-direction: column!important;\n    flex-direction: column!important;\n}\n\n.modal-wrap .close {\n    position: absolute;\n    z-index: 2;\n    right: 20px;\n    top: 15px;\n}\n\n.mrl-5less {\n    margin-left: -5px;\n    margin-right: -5px;\n}\n\n.mrl-15less {\n    margin-left: -15px;\n    margin-right: -15px;\n}\n\n.crl-15less span {\n    padding-left: 5px;\n    padding-right: 5px;\n    margin-bottom: 4px;\n}\n\n.br-left {\n    position: relative;\n}\n\n.br-left::before {\n    width: 3px;\n    height: 25px;\n    background-color: #EC9A20;\n    position: absolute;\n    content: \"\";\n    left: 15px;\n    top: 5px;\n}\n\n.list-orange li {\n    position: relative;\n    padding-left: 30px;\n}\n\n.list-orange li .badge {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #EF6910;\n    color: #fff;\n}\n\n.scheduled {\n    background-color: #EEF4FF;\n    padding: 20px;\n    color: #000;\n    border-radius: 4px;\n\n    p {\n    padding-left: 35px;\n    position: relative;\n    }\n\n    img {\n    position: absolute;\n    left: 0;\n    }\n}\n\np{\n    &.list-number {\n        position: relative;\n        padding-left: 30px;\n\n        .badge {\n            position: absolute;\n            left: 0;\n            top: 0;\n            width: 24px;\n            height: 24px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background-color: #EF6910;\n            color: #fff;\n        }\n    }\n}\n\n@media (max-width: 575.98px) {}\n\n@media (max-width: 767.98px) {}\n\n@media (max-width: 991.98px) {\n    &.bg-blue:after {\n        width: 100%;\n        background-color: transparent;\n    }\n    .bg-blue-mobile {\n        width: 100%;\n        background-color: #022D6D !important;\n    }\n    .right {\n        padding: 0px;\n    }\n    .d-none-mobile {\n        display: none;\n    }\n    .d-none-desktop {\n        display: block;\n    }\n    .container-wrap {\n        width: 100% !important;\n        max-width: 100% !important;\n    }\n    a[aria-expanded=\"true\"]>u.read {\n        font-size: 0;\n    }\n    a[aria-expanded=\"true\"]>u.read::after {\n        content: 'Read Less';\n        font-size: 14px;\n    }\n    .fixed-btn-bg {\n        position: fixed;\n        bottom: -65px;\n        right: 0;\n        left: 0;\n        background: #fff;\n        padding: 10px 0;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n        width: 100% !important;\n        display: flex;\n        justify-content: center;\n    }\n    .fixed-btn-bg.smart-scroll.scrolled-up {\n        bottom: 0;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -ms-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n    }\n    .fixed-btn-bg .btn {\n        width: 100% !important;\n        max-width: 250px;\n        margin: 0 !important;\n    }\n}\n\n@media (max-width: 1199.98px) {}\n\n@media (min-width: 1199.98px) {\n    .d-none-desktop {\n        display: none;\n    }\n}\n}",".basUI {\n  /* input, select, radio, check box styles */\n}\n.basUI header {\n  box-shadow: none;\n}\n.basUI .height-40 {\n  min-height: 40px !important;\n}\n.basUI .hr-line {\n  margin: 30px 0;\n  height: 1px;\n  width: 100%;\n  display: block;\n  clear: both;\n}\n.basUI .footertxt {\n  position: relative;\n}\n.basUI .footertxt b {\n  background: #fff;\n  position: relative;\n  z-index: 1;\n  padding-right: 15px;\n}\n.basUI .footertxt:after {\n  width: 100%;\n  height: 1px;\n  background: #C5C5C5;\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 10px;\n}\n.basUI a {\n  color: #1074E9;\n}\n.basUI a:hover {\n  color: #000;\n}\n.basUI .form-control {\n  border-radius: 6px;\n  min-height: 40px;\n  border: 0;\n}\n.basUI input.form-control::-moz-placeholder, .basUI select.form-control::-moz-placeholder, .basUI textarea::-moz-placeholder {\n  font-size: 14px;\n  color: #0D4582;\n}\n.basUI input.form-control::placeholder,\n.basUI select.form-control::placeholder,\n.basUI textarea::placeholder {\n  font-size: 14px;\n  color: #0D4582;\n}\n.basUI select.form-control option:first-child {\n  color: #0D4582;\n}\n.basUI select.form-control {\n  font-size: 13px;\n}\n.basUI ul,\n.basUI li {\n  font-size: 14px;\n}\n.basUI p {\n  font-size: 14px;\n}\n.basUI .btn {\n  border-radius: 100px;\n  min-height: 45px;\n  font-size: 14px;\n}\n.basUI .btn-primary {\n  background-color: #93CF0C;\n  border: 0;\n  color: #fff;\n}\n.basUI .btn-primary:hover {\n  background-color: #69910F;\n}\n.basUI .btn-secondary {\n  background-color: #217AFF;\n  border: 0;\n}\n.basUI .btn-secondary:hover {\n  background-color: #022D6D;\n}\n.basUI select {\n  background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #fff, #fff);\n  background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;\n  background-size: 5px 5px, 5px 5px, 1px 1.5em;\n  background-repeat: no-repeat;\n}\n.basUI select {\n  /* styling */\n  background-color: white;\n  border: thin solid blue;\n  border-radius: 4px;\n  display: inline-block;\n  font: inherit;\n  line-height: 1.5em;\n  padding: 0.5em 3.5em 0.5em 1em;\n  /* reset */\n  margin: 0;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right: 35px !important;\n}\n.basUI.bg-blue {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.basUI.bg-blue:after {\n  background-color: #022D6D;\n  width: 55%;\n  position: fixed;\n  right: 0;\n  top: 0;\n  height: 100%;\n  content: \"\";\n  z-index: 0;\n}\n.basUI .container-wrap {\n  position: relative;\n  z-index: 1;\n}\n.basUI .head-line {\n  position: relative;\n  padding-bottom: 10px;\n}\n.basUI .head-line:after {\n  background-color: #A2E609;\n  position: absolute;\n  width: 40px;\n  height: 3px;\n  content: \"\";\n  bottom: 0;\n  left: 0;\n}\n.basUI .progress-edit {\n  height: 6px;\n  border-radius: 50px;\n  background: #051C3E;\n}\n.basUI .progress-edit .bg-success {\n  height: 6px;\n  border-radius: 50px;\n  background-color: #84B80F !important;\n}\n.basUI #myTab * {\n  transition: all 0.15s ease-in-out;\n}\n.basUI .nav-tabs-custom {\n  border-bottom: 0;\n}\n.basUI .nav-tabs-custom .nav-link.active,\n.basUI .nav-tabs-custom .nav-link {\n  background-color: transparent;\n  border: none;\n  color: #fff;\n}\n.basUI .nav-tabs-custom .nav-link {\n  background-color: transparent;\n  border: none;\n  color: #98BBDF;\n  padding: 0 0 7px;\n  margin-right: 40px;\n  font-size: 14px;\n  position: relative;\n}\n.basUI .nav-tabs-custom .nav-link::after {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  content: \"\";\n  width: 0;\n  background: #2C60AE;\n  height: 2px;\n  transition: all 0.15s ease-in-out;\n}\n.basUI .nav-tabs-custom .nav-link.active {\n  padding-bottom: 7px;\n}\n.basUI .nav-tabs-custom .nav-link.active::after {\n  width: 100%;\n  transition: all 0.15s ease-in-out;\n}\n.basUI .right {\n  padding: 0 100px;\n}\n.basUI .custom-choose input[type=radio],\n.basUI .custom-choose input[type=checkbox] {\n  display: none;\n}\n.basUI .custom-choose input[type=radio] + label,\n.basUI .custom-choose input[type=radio]:not(checked) + label,\n.basUI .custom-choose input[type=checkbox] + label,\n.basUI .custom-choose input[type=checkbox]:not(checked) + label {\n  padding-left: 15px;\n  transition: 0.4s;\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  border: 0;\n  border-radius: 6px;\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  min-height: 40px;\n  font-size: 14px;\n  background-image: url(\"https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/checked.svg\");\n  background-position: right;\n  background-repeat: no-repeat;\n}\n.basUI .custom-choose label {\n  position: relative;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  color: #000;\n}\n.basUI .custom-choose label i.tick {\n  position: absolute;\n  right: 15px;\n  font-size: 16px;\n  top: 15px;\n}\n.basUI .custom-choose label i.tick:before {\n  color: #D5D5D5;\n}\n.basUI .custom-choose input[type=checkbox]:checked + label i:before,\n.basUI .custom-choose input[type=radio]:checked + label i:before {\n  color: #fff;\n}\n@media (min-width: 1200px) {\n  .basUI .custom-choose .col-xl-3 {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n}\n.basUI .custom-choose input[type=radio]:checked + label,\n.basUI .custom-choose input[type=checkbox]:checked + label {\n  position: relative;\n  border: solid 2px #217AFF;\n  background: #217AFF;\n  color: #FFF;\n  transition: 0.4s;\n  border: 0;\n  background-image: url(\"https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/checked-white.svg\");\n  background-position: right;\n  background-repeat: no-repeat;\n}\n.basUI .custom-choose span.col {\n  padding: 0 5px;\n  color: #D5D5D5;\n}\n.basUI .custom-choose .height-60 label {\n  height: 60px;\n  display: inherit;\n  flex-direction: column !important;\n}\n.basUI .modal-wrap .close {\n  position: absolute;\n  z-index: 2;\n  right: 20px;\n  top: 15px;\n}\n.basUI .mrl-5less {\n  margin-left: -5px;\n  margin-right: -5px;\n}\n.basUI .mrl-15less {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n.basUI .crl-15less span {\n  padding-left: 5px;\n  padding-right: 5px;\n  margin-bottom: 4px;\n}\n.basUI .br-left {\n  position: relative;\n}\n.basUI .br-left::before {\n  width: 3px;\n  height: 25px;\n  background-color: #EC9A20;\n  position: absolute;\n  content: \"\";\n  left: 15px;\n  top: 5px;\n}\n.basUI .list-orange li {\n  position: relative;\n  padding-left: 30px;\n}\n.basUI .list-orange li .badge {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #EF6910;\n  color: #fff;\n}\n.basUI .scheduled {\n  background-color: #EEF4FF;\n  padding: 20px;\n  color: #000;\n  border-radius: 4px;\n}\n.basUI .scheduled p {\n  padding-left: 35px;\n  position: relative;\n}\n.basUI .scheduled img {\n  position: absolute;\n  left: 0;\n}\n.basUI p.list-number {\n  position: relative;\n  padding-left: 30px;\n}\n.basUI p.list-number .badge {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #EF6910;\n  color: #fff;\n}\n@media (max-width: 991.98px) {\n  .basUI.bg-blue:after {\n    width: 100%;\n    background-color: transparent;\n  }\n  .basUI .bg-blue-mobile {\n    width: 100%;\n    background-color: #022D6D !important;\n  }\n  .basUI .right {\n    padding: 0px;\n  }\n  .basUI .d-none-mobile {\n    display: none;\n  }\n  .basUI .d-none-desktop {\n    display: block;\n  }\n  .basUI .container-wrap {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n  .basUI a[aria-expanded=true] > u.read {\n    font-size: 0;\n  }\n  .basUI a[aria-expanded=true] > u.read::after {\n    content: \"Read Less\";\n    font-size: 14px;\n  }\n  .basUI .fixed-btn-bg {\n    position: fixed;\n    bottom: -65px;\n    right: 0;\n    left: 0;\n    background: #fff;\n    padding: 10px 0;\n    transition: all 0.3s ease-in-out;\n    width: 100% !important;\n    display: flex;\n    justify-content: center;\n  }\n  .basUI .fixed-btn-bg.smart-scroll.scrolled-up {\n    bottom: 0;\n    transition: all 0.3s ease-in-out;\n  }\n  .basUI .fixed-btn-bg .btn {\n    width: 100% !important;\n    max-width: 250px;\n    margin: 0 !important;\n  }\n}\n@media (min-width: 1199.98px) {\n  .basUI .d-none-desktop {\n    display: none;\n  }\n}/*# sourceMappingURL=BASstyles.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
